import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';

export interface NotificationItem {
  notificationId: number;
  opener: string;
  notifyAbout: string;
  message: string;
  notifiedOn: string;
}

export interface NotificationListBody {
  maxPageNumber: number;
  // The API's field name has a typo (unReadNotificatiion, not
  // unReadNotification) — confirmed as-is against the real response.
  unReadNotificatiion: NotificationItem[];
}

// Notifications — parent mobile app's in-app inbox (NotificationInfo.js).
// Web-only in scope here: no FCM/push wiring, matching the REST list +
// mark-as-read pair the mobile screen itself uses (its own opener->screen
// switch is separate from the push-notification service and is NOT shared
// with it — see navigationToPage in the API reference this was built from).
@Injectable({ providedIn: 'root' })
export class ParentNotificationsService {

  private base = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) { }

  private authHeaders(): HttpHeaders | undefined {
    const raw = localStorage.getItem('authToken');
    if (!raw) { return undefined; }
    try {
      return new HttpHeaders().append('authToken', JSON.parse(raw));
    } catch {
      return new HttpHeaders().append('authToken', raw);
    }
  }

  getNotifications(studentId: string, pageNumber: number, pageLimit: number) {
    // lang is deliberately always 'en' — see the same constraint applied
    // across every other parent-portal endpoint in this app.
    return this.http.get(`${this.base}/get/parent/unread/notifications`, {
      headers: this.authHeaders(),
      params: { lang: 'en', studentId: studentId || '', pageNumber: String(pageNumber), pageLimit: String(pageLimit) },
    });
  }

  markNotificationRead(studentId: string, notificationId: number | 'All') {
    return this.http.put(`${this.base}/mark/parent/read/notification`, {
      lang: 'en',
      studentId,
      notificationId,
    }, { headers: this.authHeaders() });
  }
}
